import REG from "./regular";
import _ from "lodash";
import i18n from "./i18n";
// 用户名
export function validateUserName(value, fn) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.accountNull");
  } else if (!REG.validateZh.test(value)) {
    return REG.validateZhMsg;
  } else {
    if (typeof fn == "function") {
      return fn();
    } else {
      return false;
    }
  }
}

// 密码验证
export function validatePsd(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.passwordNull");
  } else if (!REG.validatePsd.test(value)) {
    return REG.validatePsdMsg;
  }
  return false;
}

// 支付密码
export function validatePayPsd(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.payPsdNull");
  } else if (!REG.validatePayPsd.test(value)) {
    return REG.validatePayPsdMsg;
  } else {
    return false;
  }
}

// 手机验证
export function validateMobile(value, bol) {
  if (bol && _.isEmpty(value)) {
    return false;
  }
  if (_.isEmpty(value)) {
    return i18n.t("verify.mobileNull");
  } else if (!REG.validateMobile.test(value)) {
    return REG.validateMobileMsg;
  }
  return false;
}

//手机验证不能为空
export function validateMobile1(value, bol) {
  if (bol && _.isEmpty(value)) {
    return false;
  }
  if (_.isEmpty(value)) {
    return i18n.t("verify.mobileNull");
  } else if (!REG.validateMobile1.test(value)) {
    return REG.validateMobileMsg;
  }
  return false;
}

// 邮箱验证
export function validateEmail(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.emailNull");
  } else if (!REG.validateEmail.test(value)) {
    return REG.validateEmailMsg;
  }
  return false;
}

// 时间
export function validateBirthday(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.timeNull");
  } else if (REG.birthday.test(value)) {
    return REG.birthdayMsg;
  }
  return false;
}

// 姓名
export function validteRealname(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.realnameNull");
  } else if (!REG.realname.test(value)) {
    return REG.realnameMsg;
  }
  return false;
}

// 昵称验证
export function validateNickname(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.nicknameMsg");
  } else if (!REG.nickname.test(value)) {
    return REG.nicknameMsg;
  }
  return false;
}

// 分组名称
export function validateGroupName(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.groupNameMsg");
  } else if (!REG.groupName.test(value)) {
    return REG.groupNameMsg;
  }
  return false;
}

// 支付宝
export function validteAliPay(value) {
  if (!REG.aliPay.test(value)) {
    return REG.aliPayMsg;
  }
  return false;
}
// 微信
export function validteWeChat(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.weChatNull");
  } else if (!REG.weChat.test(value)) {
    return REG.weChatMsg;
  }
  return false;
}
// qq
export function validteQQ(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.QQNull");
  }
  return false;
}
// 银行卡号
export function validteBankCardNumber(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.bankAccountNumberNull");
  } else if (!REG.bankAccountNumber.test(value)) {
    return REG.bankAccountNumberMsg;
  } else {
    return false;
  }
}

// 验证码
export function validateCode(value) {
  if (_.isEmpty(value)) {
    return i18n.t("verify.verificationCodeNull");
  }
  return false;
}
